<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Varning-callout
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Amber-tonad varningsruta med triangelikon. Används för kritiska råd där
      misstag påverkar resultatet märkbart.
    </p>

    <PreviewFull label="Exempel">
      <div
        class="w-full flex gap-3 p-5 rounded-2xl"
        style="
          background: rgba(245, 158, 11, 0.06);
          border: 1px solid rgba(245, 158, 11, 0.25);
        "
      >
        <div class="flex-shrink-0 mt-0.5">
          <AlertTriangle :size="20" color="#f59e0b" />
        </div>
        <div>
          <p class="font-[Poppins] font-bold text-[14px] text-[#191c1e] mb-1">
            Viktigt
          </p>
          <p
            class="font-[Plus_Jakarta_Sans] text-[14px] text-[#3c4947] leading-[1.6] m-0"
          >
            Vätskan får aldrig vara varmare än 38 °C när du tillsätter jästen –
            annars dör jästsvampen och degen jäser inte.
          </p>
        </div>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { AlertTriangle } from "lucide-vue-next";
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="flex gap-3 p-5 rounded-2xl"
  style="background: rgba(245,158,11,0.06); border: 1px solid rgba(245,158,11,0.25)">
  <AlertTriangle :size="20" color="#f59e0b" class="flex-shrink-0 mt-0.5" />
  <div>
    <p class="font-[Poppins] font-bold text-[14px] text-[#191c1e] mb-1">Obs!</p>
    <p class="font-[Plus_Jakarta_Sans] text-[14px] text-[#3c4947] leading-[1.6] m-0">
      Din varningstext här.
    </p>
  </div>
</div>`;

const cssCode = `/* Bakgrund */
background: rgba(245,158,11,0.06);

/* Kant */
border: 1px solid rgba(245,158,11,0.25);

/* Radie */
border-radius: 16px;   /* rounded-2xl */

/* Ikon: AlertTriangle (lucide-vue-next), 20px, color #f59e0b */

/* Rubrik */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 14px;

/* Brödtext */
font-family: 'Plus Jakarta Sans', sans-serif;
font-size: 14px;
color: #3c4947;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
